export default "__VITE_ASSET__CzohAwL0__"